export default "__VITE_ASSET__zHc7WPP3__"